import { use } from 'react';
import { JWTContext } from 'contexts/JWTContext';

// ==============================|| AUTH - HOOKS ||============================== //

export default function useAuth() {
  const context = use(JWTContext);

  if (!context) throw new Error('useAuth must be used inside JWTProvider');

  return context;
}
